
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { SendHorizontal } from "lucide-react";
import { VoiceInputButton } from "./VoiceInputButton";

interface ChatInputProps {
  sendMessage: (message: string) => void;
  isLoading: boolean;
  placeholder?: string;
}

const ChatInput: React.FC<ChatInputProps> = ({ 
  sendMessage, 
  isLoading,
  placeholder = "Ask about React concepts, SQL queries, or programming topics..."
}) => {
  const [message, setMessage] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      sendMessage(message);
      setMessage("");
    }
  };

  return (
    <form className="w-full flex gap-2" onSubmit={handleSubmit}>
      <VoiceInputButton onTranscript={(text) => setMessage(text)} />
      <Input
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder={placeholder}
        disabled={isLoading}
        className="flex-1"
      />
      <Button type="submit" disabled={isLoading || !message.trim()}>
        <SendHorizontal className="h-4 w-4" />
        <span className="ml-2 hidden sm:inline">Send</span>
      </Button>
    </form>
  );
};

export default ChatInput;
